import { MfaPage } from '@mfa/commun-react';
import React, { Component } from 'react';
import { InformationsComplementaires } from './InformationsComplementaires';
import './Page.js.css';

export class Page extends Component {
    render() {
        return (
            <MfaPage
                titre='Informations complémentaires'
                adresseRoutes="Api/ICSG/ObtenirRoutes"
                proprietesRoutes={{}}
                dictionnaireRoutes={{
                    InformationsComplementaires: InformationsComplementaires,
                }}
                fermetureSessionInfo={{}}
            />
        );
    }
}
